import { Box, Container, FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";

const SettingsNotifications = ({ isDesktop = false }) => {
  const navigate = useNavigate();
  const [marketingUpdates, setMarketingUpdates] = useState(true);
  const [gameReminders, setGameReminders] = useState(true);
  const [paymentNotifications, setPaymentNotifications] = useState(true);

  const handleBack = () => {
    navigate("/settings");
  };

  const handleMarketingUpdatesChange = (event) => {
    setMarketingUpdates(event.target.checked);
  };

  const handleGameRemindersChange = (event) => {
    setGameReminders(event.target.checked);
  };

  const handlePaymentNotificationsChange = (event) => {
    setPaymentNotifications(event.target.checked);
  };

  const handleSave = () => {
    // TODO: Implement save logic
  };

  // Desktop layout (no container, no back button)
  if (isDesktop) {
    return (
      <Box>
        {/* Notification Settings */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            mb: "40px",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={marketingUpdates}
                onChange={handleMarketingUpdatesChange}
                sx={{
                  width: 51,
                  height: 31,
                  padding: 0,
                  "& .MuiSwitch-switchBase": {
                    padding: 0,
                    margin: "2px",
                    transitionDuration: "300ms",
                    "&.Mui-checked": {
                      transform: "translateX(20px)",
                      color: "#fff",
                      "& + .MuiSwitch-track": {
                        backgroundColor: "#1890FF",
                        opacity: 1,
                        border: 0,
                      },
                    },
                  },
                  "& .MuiSwitch-thumb": {
                    boxSizing: "border-box",
                    width: 27,
                    height: 27,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  },
                  "& .MuiSwitch-track": {
                    borderRadius: 31 / 2,
                    backgroundColor: "#D4D4D4",
                    opacity: 1,
                    transition: "background-color 200ms ease-in-out",
                    border: "none",
                  },
                }}
              />
            }
            label="Marketing & Product Updates"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              m: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: 400,
                color: "#000",
                flex: 1,
              },
            }}
            labelPlacement="start"
          />

          <FormControlLabel
            control={
              <Switch
                checked={gameReminders}
                onChange={handleGameRemindersChange}
                sx={{
                  width: 51,
                  height: 31,
                  padding: 0,
                  "& .MuiSwitch-switchBase": {
                    padding: 0,
                    margin: "2px",
                    transitionDuration: "300ms",
                    "&.Mui-checked": {
                      transform: "translateX(20px)",
                      color: "#fff",
                      "& + .MuiSwitch-track": {
                        backgroundColor: "#1890FF",
                        opacity: 1,
                        border: 0,
                      },
                    },
                  },
                  "& .MuiSwitch-thumb": {
                    boxSizing: "border-box",
                    width: 27,
                    height: 27,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  },
                  "& .MuiSwitch-track": {
                    borderRadius: 31 / 2,
                    backgroundColor: "#D4D4D4",
                    opacity: 1,
                    transition: "background-color 200ms ease-in-out",
                    border: "none",
                  },
                }}
              />
            }
            label="Game Reminders"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              m: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: 400,
                color: "#000",
                flex: 1,
              },
            }}
            labelPlacement="start"
          />

          <FormControlLabel
            control={
              <Switch
                checked={paymentNotifications}
                onChange={handlePaymentNotificationsChange}
                sx={{
                  width: 51,
                  height: 31,
                  padding: 0,
                  "& .MuiSwitch-switchBase": {
                    padding: 0,
                    margin: "2px",
                    transitionDuration: "300ms",
                    "&.Mui-checked": {
                      transform: "translateX(20px)",
                      color: "#fff",
                      "& + .MuiSwitch-track": {
                        backgroundColor: "#1890FF",
                        opacity: 1,
                        border: 0,
                      },
                    },
                  },
                  "& .MuiSwitch-thumb": {
                    boxSizing: "border-box",
                    width: 27,
                    height: 27,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  },
                  "& .MuiSwitch-track": {
                    borderRadius: 31 / 2,
                    backgroundColor: "#D4D4D4",
                    opacity: 1,
                    transition: "background-color 200ms ease-in-out",
                    border: "none",
                  },
                }}
              />
            }
            label="Payment Notifications"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              m: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: 400,
                color: "#000",
                flex: 1,
              },
            }}
            labelPlacement="start"
          />
        </Box>

        {/* Save Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="primary"
            onClick={handleSave}
            sx={{ minWidth: "120px", width: "auto" }}
          >
            Save
          </Button>
        </Box>
      </Box>
    );
  }

  // Mobile layout (original)
  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      {/* Back Button */}
      <Box sx={{ mb: "24px" }}>
        <Button variant="back" onClick={handleBack} />
      </Box>

      {/* Page Header */}
      <Text variant="pageHeader" sx={{ mb: "40px" }}>
        Email notifications
      </Text>

      {/* Notification Settings */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          mb: "40px",
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={marketingUpdates}
              onChange={handleMarketingUpdatesChange}
              sx={{
                width: 51,
                height: 31,
                padding: 0,
                "& .MuiSwitch-switchBase": {
                  padding: 0,
                  margin: "2px",
                  transitionDuration: "300ms",
                  "&.Mui-checked": {
                    transform: "translateX(20px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#1890FF",
                      opacity: 1,
                      border: 0,
                    },
                  },
                },
                "& .MuiSwitch-thumb": {
                  boxSizing: "border-box",
                  width: 27,
                  height: 27,
                  backgroundColor: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                },
                "& .MuiSwitch-track": {
                  borderRadius: 31 / 2,
                  backgroundColor: "#D4D4D4",
                  opacity: 1,
                  transition: "background-color 200ms ease-in-out",
                  border: "none",
                },
              }}
            />
          }
          label="Marketing & Product Updates"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            m: 0,
            "& .MuiFormControlLabel-label": {
              fontSize: "16px",
              fontWeight: 400,
              color: "#000",
              flex: 1,
            },
          }}
          labelPlacement="start"
        />

        <FormControlLabel
          control={
            <Switch
              checked={gameReminders}
              onChange={handleGameRemindersChange}
              sx={{
                width: 51,
                height: 31,
                padding: 0,
                "& .MuiSwitch-switchBase": {
                  padding: 0,
                  margin: "2px",
                  transitionDuration: "300ms",
                  "&.Mui-checked": {
                    transform: "translateX(20px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#1890FF",
                      opacity: 1,
                      border: 0,
                    },
                  },
                },
                "& .MuiSwitch-thumb": {
                  boxSizing: "border-box",
                  width: 27,
                  height: 27,
                  backgroundColor: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                },
                "& .MuiSwitch-track": {
                  borderRadius: 31 / 2,
                  backgroundColor: "#D4D4D4",
                  opacity: 1,
                  transition: "background-color 200ms ease-in-out",
                  border: "none",
                },
              }}
            />
          }
          label="Game Reminders"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            m: 0,
            "& .MuiFormControlLabel-label": {
              fontSize: "16px",
              fontWeight: 400,
              color: "#000",
              flex: 1,
            },
          }}
          labelPlacement="start"
        />

        <FormControlLabel
          control={
            <Switch
              checked={paymentNotifications}
              onChange={handlePaymentNotificationsChange}
              sx={{
                width: 51,
                height: 31,
                padding: 0,
                "& .MuiSwitch-switchBase": {
                  padding: 0,
                  margin: "2px",
                  transitionDuration: "300ms",
                  "&.Mui-checked": {
                    transform: "translateX(20px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#1890FF",
                      opacity: 1,
                      border: 0,
                    },
                  },
                },
                "& .MuiSwitch-thumb": {
                  boxSizing: "border-box",
                  width: 27,
                  height: 27,
                  backgroundColor: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                },
                "& .MuiSwitch-track": {
                  borderRadius: 31 / 2,
                  backgroundColor: "#D4D4D4",
                  opacity: 1,
                  transition: "background-color 200ms ease-in-out",
                  border: "none",
                },
              }}
            />
          }
          label="Payment Notifications"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            m: 0,
            "& .MuiFormControlLabel-label": {
              fontSize: "16px",
              fontWeight: 400,
              color: "#000",
              flex: 1,
            },
          }}
          labelPlacement="start"
        />
      </Box>

      {/* Save Button */}
      <Button variant="primary" onClick={handleSave} sx={{ width: "100%" }}>
        Save
      </Button>
    </Container>
  );
};

export default SettingsNotifications;
